module.exports = __webpack_public_path__ + "static/coast-7b89ce26fa1fd9f617531766c2e2565a.gif";